import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import urlsToLinks from 'scoreboard/components/urls-to-links'
import momentHelper from 'scoreboard/components/moment-helper'
import noteTemplate from './designer-note.hbs'
import noteExportTemplate from './designer-note-export.hbs'
import reportConstants from 'scoreboard/reports/report-constants'
import { appliesTo } from 'scoreboard/notes/reply-form'

function parseNote(note, section) {
	let formattedNote = _.cloneDeep(note)
	formattedNote.rawText = note.text
	// preserve line breaks
	if (!note.html) {
		formattedNote.text = urlsToLinks(escapePreserveLineBreaks(note.text))
	}
	formattedNote.appliesToLabel = appliesTo(note, section)
	formattedNote.createdDateLabel = momentHelper.formatDate(note.created)
	return formattedNote
}

function buildByline(displayProps, formattedNote) {
	let byline = []
	if (displayProps[reportConstants.NOTE_DISPLAY_PROP_APPLIES_TO]) {
		byline.push(i18n.get('report.designer.noteByline.appliesTo', formattedNote.appliesToLabel))
	}
	if (displayProps[reportConstants.NOTE_DISPLAY_PROP_DOMAIN_LABEL]) {
		byline.push(formattedNote.domainLabel)
	}
	if (displayProps[reportConstants.NOTE_DISPLAY_PROP_AUTHOR]) {
		byline.push(i18n.get('report.designer.noteByline.byAuthor', formattedNote.lastModifier.label))
	}
	if (displayProps[reportConstants.NOTE_DISPLAY_PROP_CREATED_DATE]) {
		byline.push(i18n.get('report.designer.noteByline.onDate', formattedNote.createdDateLabel))
	}
	if (byline.length == 0) {
		return null
	}
	return byline.join(' ') + ':'
}

function formatNote(result, displayProperties, notes, section) {
	result.html = ''
	let exportValue = ''
	_.each(notes, note => {
		let formattedNote = parseNote(note, section)
		let templateContext = {note: formattedNote, byline: buildByline(displayProperties, formattedNote)}
		let html = noteTemplate(templateContext)
		exportValue = noteExportTemplate(templateContext)
		//if note has replies and we're showing replies
		if (note.replies && displayProperties[reportConstants.NOTE_DISPLAY_PROP_REPLIES]) {
			_.each(note.replies, reply => {
				let formattedReply = parseNote(reply, section)
				//only show the author and date for replies?
				let replyDisplayProperties = _.pick(displayProperties, [
					reportConstants.NOTE_DISPLAY_PROP_AUTHOR, reportConstants.NOTE_DISPLAY_PROP_CREATED_DATE
				])
				templateContext = {
					note: formattedReply,
					byline: buildByline(replyDisplayProperties, formattedReply),
					extraClass: 'reply'
				}
				html += noteTemplate(templateContext)
				exportValue += '\n'+noteExportTemplate(templateContext)
			})
		}
		result.html += html
	})
	result.dataValueType = 'text'
	result.exportValue = exportValue
	result.style['note-content'] = true
	return result
}

export default formatNote
formatNote.__filename__ = 'reports/common/designer-note-formatter.js'
